var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-train-open font-weight-light color-1-5",style:(`
    ${_vm.wbline_ids?`height: ${_vm.bl_height};`:`height: calc(${_vm.taktarea_count} * (var(--workpackage_height) + 8px) * var(--taktplan_zoom));`}
    `)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }